import { productPartNumbersStyles as styles } from "@insite/content-library/Components/ProductPartNumbers";
import { css } from "styled-components";

const commonLabelStyles = css`
    font-weight: bold;
    margin-inline-end: 0.5rem;
    position: relative;

    &::after {
        content: ": ";
        position: absolute;
    }
`;

styles.erpNumberLabelText = {
    ...styles.erpNumberLabelText,
    css: css`
        ${commonLabelStyles}
    `,
};
styles.customerNameLabelText = {
    ...styles.customerNameLabelText,
    css: css`
        ${commonLabelStyles}
    `,
};
styles.manufacturerItemLabelText = {
    ...styles.manufacturerItemLabelText,
    css: css`
        ${commonLabelStyles}
    `,
};
